import { DownloadableData } from '@order-management/types';
import FileSaver from 'file-saver';

export const useCSVDownload = () => {
  const downloadCSV = (data: DownloadableData<string>) => {
    const blob = new Blob([data.fileContent], { type: 'text/csv' });
    FileSaver.saveAs(blob, data.fileName);
  };

  return { downloadCSV };
};
